export const applicationPostMock = {
  "id": "bba7f997-9cdb-4265-9fde-2b828a8e05df",
  "user": {
    "id": "QTAzGe_QkO58yLhu4wd0ypVDxQ",
    "userId": "bba7f997-9cdb-4265-9fde-2b828a8e05df",
    "primaryPhone": "+381665126482",
    "href": "https://engdobs-idx45-qc.identityx-cloud.com/onboardingdemo/IdentityXServices/rest/v1/users/QTAzGe_QkO58yLhu4wd0ypVDxQ",
    "relHref": "/onboardingdemo/IdentityXServices/rest/v1/users/QTAzGe_QkO58yLhu4wd0ypVDxQ"
  }
}